import { render } from "./LlmPrompts.vue?vue&type=template&id=1070b6f4"
import script from "./LlmPrompts.vue?vue&type=script&lang=js"
export * from "./LlmPrompts.vue?vue&type=script&lang=js"

import "./LlmPrompts.vue?vue&type=style&index=0&id=1070b6f4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__